module.exports = __webpack_public_path__ + "img/d26ff81.png";